import { SaveDirtyKitchenLocally } from '@features/customer/helpers';

/**
 * The locally autosaved drafts belonging to one customer, keyed by blueprint id.
 * @param email customer whose drafts to collect
 * @returns the drafts, keyed by the blueprint each one belongs to
 */
export const readAutosaveEntries = (email: string | null): Record<string, SaveDirtyKitchenLocally> => {
	const autosaveEntries: Record<string, SaveDirtyKitchenLocally> = {};

	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (key?.startsWith('autosave-')) {
			const rawValue = localStorage.getItem(key);
			const value: SaveDirtyKitchenLocally | null = rawValue ? JSON.parse(rawValue) : null;
			if (value && value.blueprintId && value.customer === email) autosaveEntries[value.blueprintId] = value;
		}
	}

	return autosaveEntries;
};
